module.exports = __webpack_public_path__ + "static/media/md-volume-low.95f63787.svg";